var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { createContext, useContext, useMemo } from 'react';
import { PaperIconCache } from './PaperIconCache';
import { defaultFetch } from './api';
export var DEFAULT_CACHE = new PaperIconCache();
export var DEFAULT_COLLECTION = 'lindua';
export var paperIconConfigContext = createContext({
    cache: DEFAULT_CACHE,
    collection: DEFAULT_COLLECTION,
    env: 'infer',
    fetch: defaultFetch,
});
var Provider = paperIconConfigContext.Provider;
/**
 * Change the default settings for <PaperIcon>
 */
export function PaperIconConfigProvider(_a) {
    var _b;
    var children = _a.children, overrides = __rest(_a, ["children"]);
    var context = useContext(paperIconConfigContext);
    var newContext = useMemo(function () { return (__assign(__assign({}, context), overrides)); }, __spreadArray([
        context
    ], (_b = []).concat.apply(_b, Object.entries(overrides)), true));
    return React.createElement(Provider, { value: newContext }, children);
}
//# sourceMappingURL=PaperIconConfigContext.js.map